export default ({ BREAKPOINTS }) => ({
  wrapper: {
    maxWidth: '370px',
    width: '100vw',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      padding: '0 20px',
      maxWidth: '370px'
    }
  }
})
